exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Oodu{padding:0 5px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1t-By,._2zWWe{border-radius:3px;background:#f5f5f5}._2zWWe{height:360px;position:relative}._1t-By{width:173px}._2zWWe._1RQRQ{background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.2)),to(rgba(253,191,0,.2))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff}._2zWWe:hover{-webkit-box-shadow:0 0 30px rgba(0,0,0,.15);box-shadow:0 0 30px rgba(0,0,0,.15);background:#fff}._1WT0N{text-align:center;vertical-align:middle;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;height:170px}._1t-By ._1WT0N{height:125px}._1t-By .XgIVu{height:85px}._2f8em{position:absolute;height:100%;width:100%;top:0;left:0}.XgIVu{position:relative;padding:10px}.VAwNC{position:absolute;top:0;left:0;right:0;width:100%;height:100%;color:#fff;padding:10px;background:#0004}._1WT0N:hover+.VAwNC{opacity:0}", ""]);

// exports
exports.locals = {
	"root": "_2Oodu",
	"isVip": "_1RQRQ",
	"similar": "_1t-By",
	"promoutedcard": "_2zWWe",
	"thumb": "_1WT0N",
	"subInfo": "XgIVu",
	"link": "_2f8em",
	"brick": "VAwNC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertCarCard/AdvertCarCard.css
// module id = 1774
// module chunks = 20 21 23 32 33 38